<script lang="ts">
  import { Check, Minus } from '@lucide/svelte';
  interface Props {
    checked?: boolean;
    indeterminate?: boolean;
    label?: string;
    disabled?: boolean;
    onchange?: (checked: boolean, event: MouseEvent) => void;
    ariaLabel?: string;
  }
  let { checked = $bindable(false), indeterminate = false, label, disabled = false, onchange, ariaLabel }: Props = $props();
  function click(event: MouseEvent) {
    event.stopPropagation();
    if (disabled) return;
    checked = !checked;
    onchange?.(checked, event);
  }
</script>

<button type="button" role="checkbox" aria-checked={indeterminate ? 'mixed' : checked} aria-label={ariaLabel || label} class="cb" class:on={checked || indeterminate} {disabled} onclick={click}>
  <span class="box">
    {#if indeterminate}<Minus size={12} strokeWidth={3} />{:else if checked}<Check size={12} strokeWidth={3} />{/if}
  </span>
  {#if label}<span class="lbl">{label}</span>{/if}
</button>

<style>
  .cb { display: inline-flex; align-items: center; gap: var(--space-2); background: none; border: 0; padding: var(--space-0_5); color: var(--text); font-size: var(--text-base); border-radius: var(--radius-xs); }
  .cb:focus-visible { outline: none; }
  .cb:focus-visible .box { box-shadow: var(--ring); border-color: var(--brand); }
  .box {
    width: 18px; height: 18px; border-radius: var(--radius-2xs);
    flex-shrink: 0;
    border: 1.5px solid var(--border-strong);
    background: var(--surface);
    display: grid; place-items: center; color: var(--on-brand);
    transition: background var(--dur), border-color var(--dur);
  }
  .on .box { background: var(--brand); border-color: var(--brand); }
  .cb:hover .box { border-color: var(--brand); }
  .cb:disabled { opacity: 0.5; }
</style>
